import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import DecimalRangeField from '@shared/fields/decimal-range-field';
import DecimalField from '@shared/fields/decimal-field';
import EnumeratorField from '@shared/fields/enumerator-field';

function label(name) {
  return i18n(`entities.price.fields.${name}`);
}

function enumeratorLabel(name, value) {
  return i18n(`entities.price.enumerators.${name}.${value}`);
}

const fields = {
  id: new IdField('id', label('id')),
  amount: new DecimalField('amount', label('amount'), {
    "required": true
  }),
  currency: new EnumeratorField('currency', label('currency'), [
    { id: 'eu', label: enumeratorLabel('currency', 'eu') },
    { id: 'usd', label: enumeratorLabel('currency', 'usd') },
  ],{}),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),
  amountRange: new DecimalRangeField(
    'amountRange',
    label('amountRange'),
  ),
};

export class PriceModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
